import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getTenantLanguages = (token, id = "", tenantId) => {
    return fetch(`${apiUrl}tenant_languages/${id}${tenantId ? '?TenantID=' + tenantId : ''}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getTenantLanguages